import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhoFor } from './components/WhoFor';
import { Process } from './components/Process';
import { Results } from './components/Results';
import { FAQ } from './components/FAQ';
import { BookCall } from './components/BookCall';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="min-h-screen flex flex-col relative w-full overflow-x-hidden">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <ProofBar />
        <About />
        <Services />
        <WhoFor />
        <Process />
        <Results />
        <FAQ />
        <BookCall />
      </main>
      <Footer />
    </div>
  );
}

export default App;